<div class="m-3">
  <div class="container">
    <div class="card-header text-uppercase">Dữ liệu hiện tại</div>

      <div class="row m-4">
        <div class="col-lg-4 col-md-12 col-sm-12">
          <label class="font-weight-bold">Mã điểm đo:</label> {{meterData?.ma_diemdo}}
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">
          <label class="font-weight-bold">Mã công tơ:</label> {{meterData?.serialid}}
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 d-flex">
          <label class="font-weight-bold">Ngày:</label>
          <p class="mx-2"></p>
          <div class="flex-fill">
            <dcu-date-picker [formControl]="date"
                             [maxDate]="maxDate" [minDate]="minDate"
                             (ngModelChange)="changeDate($event)"
                             placeholder="Chọn ngày để xem dữ liệu"
            ></dcu-date-picker>
          </div>
        </div>
      </div>

      <dcu-accordion [expand]="true" [headerTitle]="'Giao (kWh)'">
        <div class="row">
          <label class="card-title">Chỉ số hiện tại:</label>
        </div>
        <div class="row ml-lg-3 ml-md-2 ml-sm-1">
          <div class="col-lg-4 col-md-12">
            <label class="card-title pr-1">Biểu tổng:</label> <span class="current-meter-data">{{meterData?.sg}}</span>
          </div>
          <div class="col-lg-8 col-md-12">
            <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
              <div><label class="card-title pr-1">BT:</label> <span class="current-meter-data">{{meterData?.impbt}}</span></div>
              <div><label class="card-title pr-1">CD:</label> <span class="current-meter-data">{{meterData?.impcd}}</span></div>
              <div><label class="card-title pr-1">TD:</label> <span class="current-meter-data">{{meterData?.imptd}}</span></div>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="card-title">Chỉ số chốt tháng:</label>
          <span *ngIf="meterData?.closingTimeLastMonth"><i>&nbsp;&nbsp;({{meterData?.closingTimeLastMonth | date: 'dd/MM/yyyy'}})</i></span>
        </div>

        <div class="row ml-lg-3 ml-md-2 ml-sm-1">
          <div class="col-lg-4 col-md-12">
            <label class="card-title pr-1">Biểu tổng:</label> <span class="closing-meter-data">{{meterData?.sgLastMonth}}</span>
          </div>
          <div class="col-lg-8 col-md-12">
            <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
              <div><label class="card-title pr-1">BT:</label> <span class="closing-meter-data">{{meterData?.impbtLastMonth}}</span></div>
              <div><label class="card-title pr-1">CD:</label> <span class="closing-meter-data">{{meterData?.impcdLastMonth}}</span></div>
              <div><label class="card-title pr-1">TD:</label> <span class="closing-meter-data">{{meterData?.imptdLastMonth}}</span></div>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="card-title">Điện năng tiêu thụ:</label>
        </div>
        <div class="row ml-lg-3 ml-md-2 ml-sm-1">
          <div class="col-lg-4 col-md-12">
            <label class="card-title pr-1">Biểu tổng:</label> <span class="used-meter-data">{{meterData?.sgCurrentUsed}}</span>
          </div>
          <div class="col-lg-8 col-md-12">
            <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
              <div><label class="card-title pr-1">BT:</label> <span class="used-meter-data">{{meterData?.impbtCurrentUsed}}</span></div>
              <div><label class="card-title pr-1">CD:</label> <span class="used-meter-data">{{meterData?.impcdCurrentUsed}}</span></div>
              <div><label class="card-title pr-1">TD:</label> <span class="used-meter-data">{{meterData?.imptdCurrentUsed}}</span></div>
            </div>
          </div>
        </div>
      </dcu-accordion>

      <dcu-accordion [expand]="true" [headerTitle]="'Nhận (kWh)'">
        <div class="row">
          <label class="card-title">Chỉ số hiện tại:</label>
        </div>
        <div class="row ml-lg-3 ml-md-2 ml-sm-1">
          <div class="col-lg-4 col-md-12">
            <label class="card-title pr-1">Biểu tổng:</label> <span class="current-meter-data">{{meterData?.sn}}</span>
          </div>
          <div class="col-lg-8 col-md-12">
            <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
              <div><label class="card-title pr-1">BT:</label> <span class="current-meter-data">{{meterData?.expbt}}</span></div>
              <div><label class="card-title pr-1">CD:</label> <span class="current-meter-data">{{meterData?.expcd}}</span></div>
              <div><label class="card-title pr-1">TD:</label> <span class="current-meter-data">{{meterData?.exptd}}</span></div>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="card-title">Chỉ số chốt tháng:</label>
          <span *ngIf="meterData?.closingTimeLastMonth"><i>&nbsp;&nbsp;({{meterData?.closingTimeLastMonth | date: 'dd/MM/yyyy'}})</i></span>
        </div>
        <div class="row ml-lg-3 ml-md-2 ml-sm-1">
          <div class="col-lg-4 col-md-12">
            <label class="card-title pr-1">Biểu tổng:</label> <span class="closing-meter-data">{{meterData?.snLastMonth}}</span>
          </div>
          <div class="col-lg-8 col-md-12">
            <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
              <div><label class="card-title pr-1">BT:</label> <span class="closing-meter-data">{{meterData?.expbtLastMonth}}</span></div>
              <div><label class="card-title pr-1">CD:</label> <span class="closing-meter-data">{{meterData?.expcdLastMonth}}</span></div>
              <div><label class="card-title pr-1">TD:</label> <span class="closing-meter-data">{{meterData?.exptdLastMonth}}</span></div>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="card-title">Điện năng tiêu thụ:</label>
        </div>
        <div class="row ml-lg-3 ml-md-2 ml-sm-1">
          <div class="col-lg-4 col-md-12">
            <label class="card-title pr-1">Biểu tổng:</label> <span class="used-meter-data">{{meterData?.snCurrentUsed}}</span>
          </div>
          <div class="col-lg-8 col-md-12">
            <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
              <div><label class="card-title pr-1">BT:</label> <span class="used-meter-data">{{meterData?.expbtCurrentUsed}}</span></div>
              <div><label class="card-title pr-1">CD:</label> <span class="used-meter-data">{{meterData?.expcdCurrentUsed}}</span></div>
              <div><label class="card-title pr-1">TD:</label> <span class="used-meter-data">{{meterData?.exptdCurrentUsed}}</span></div>
            </div>
          </div>
        </div>

      </dcu-accordion>

  </div>

  <div class="container">
    <div class="card-header text-uppercase">Lịch sử tiêu thụ điện</div>
    <ng-container *ngIf="meterDataHistoryList && meterDataHistoryList.length > 0">
      <dcu-accordion *ngFor="let meterDataHistory of meterDataHistoryList" [headerTitle]="meterDataHistory.closingTime | date: 'dd/MM/yyyy'">

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <label class="card-title">Giao (kWh):</label>
            </div>
            <div class="mx-lg-3 mx-md-2 mx-sm-1">
              <label class="card-title pr-1">Biểu tổng:</label> <span class="closing-meter-data">{{meterDataHistory?._eDelivery}}</span>
            </div>
            <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
              <div>
                <label class="card-title pr-1">BT:</label> <span class="closing-meter-data">{{meterDataHistory?._eDeliveryBT}}</span>
              </div>
              <div>
                <label class="card-title pr-1">CD:</label> <span class="closing-meter-data">{{meterDataHistory?._eDeliveryCD}}</span>
              </div>
              <div>
                <label class="card-title pr-1">TD:</label> <span class="closing-meter-data">{{meterDataHistory?._eDeliveryTD}}</span>
              </div>
            </div>

        </div>

        <div class="col-md-6">
          <div class="row">
            <label class="card-title">Nhận (kWh):</label>
          </div>
          <div class="mx-lg-3 mx-md-2 mx-sm-1">
            <label class="card-title pr-1">Biểu tổng:</label> <span class="closing-meter-data">{{meterDataHistory?._eReceive}}</span>
          </div>
          <div class="d-flex justify-content-between mx-lg-3 mx-md-2 mx-sm-1">
            <div>
              <label class="card-title pr-1">BT:</label> <span class="closing-meter-data">{{meterDataHistory?._eReceiveBT}}</span>
            </div>
            <div>
              <label class="card-title pr-1">CD:</label> <span class="closing-meter-data">{{meterDataHistory?._eReceiveCD}}</span>
            </div>
            <div>
              <label class="card-title pr-1">TD:</label> <span class="closing-meter-data">{{meterDataHistory?._eReceiveTD}}</span>
            </div>
          </div>
        </div>

      </div>

      </dcu-accordion>
    </ng-container>
  </div>
</div>
